/**
 * Entry point. Applies the colour mode BEFORE the first React render, then mounts the app.
 *
 * index.html already set the Cloudscape mode class synchronously so the page does not flash white
 * (see the comment there). This call routes the same value through Cloudscape's own applyMode() so
 * its internal state matches the DOM — the pre-paint script is an optimisation, not the source of
 * truth.
 */

import '@cloudscape-design/global-styles/index.css';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { initialMode, applyColorMode } from './lib/theme.js';

applyColorMode(initialMode());

createRoot(document.getElementById('root')).render(<App />);
